// ==============================|| OVERRIDES - SCROLLBAR ||============================== //

export default function Scrollbar(theme) {
    const scrollbarThumbColor = theme.palette.mode === 'dark'
        ? '#3c3e40'
        : theme.palette.grey[400];

    const scrollbarTrackColor = theme.palette.mode === 'dark'
        ? '#69686b'
        : theme.palette.grey[100];

    const scrollbarThumbHoverColor = theme.palette.mode === 'dark'
        ? theme.palette.grey[500]
        : theme.palette.grey[500];

    return {
        MuiCssBaseline: {
            styleOverrides: {
                // Target react-window containers specifically
                '.simulation-section-content > div, .content-area > div': {
                    // Firefox
                    scrollbarWidth: 'thin',
                    scrollbarColor: `${scrollbarThumbColor} ${scrollbarTrackColor}`,

                    // Webkit browsers (Chrome, Safari, Edge)
                    '&::-webkit-scrollbar': {
                        width: '8px',
                        height: '8px',
                    },
                    '&::-webkit-scrollbar-track': {
                        background: scrollbarTrackColor,
                        borderRadius: theme.borderRadius?.sm || '12px',
                    },
                    '&::-webkit-scrollbar-thumb': {
                        background: scrollbarThumbColor,
                        borderRadius: theme.borderRadius?.sm || '12px',
                        border: `1px solid ${scrollbarTrackColor}`,
                        '&:hover': {
                            background: scrollbarThumbHoverColor,
                        },
                        '&:active': {
                            background: theme.palette.mode === 'dark'
                                ? '#3c3e40'
                                : theme.palette.grey.A800,
                        },
                    },
                    '&::-webkit-scrollbar-corner': {
                        background: scrollbarTrackColor,
                    },
                },
            },
        },
    };
}